import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IconHandLoveYou } from '@tabler/icons-react';
import routes from '@/routes';
import classes from './style.module.css';

const Main = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.main}>
      <Grid>
        <Grid.Col span={12}>
          <h1>{t('pages.main.title')}</h1>
        </Grid.Col>
        <Grid.Col span={12}>
          <IconHandLoveYou color="blue" />
        </Grid.Col>
        <Grid.Col span={12}>
          <Link to={routes.login.path}>{t('pages.main.goto')}</Link>
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default Main;
